import React, { useEffect, useState } from "react";
import config from "../../../config";
import axios from "axios";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { Link } from "react-router-dom";

const Index = () => {
  const [categories, setCategories] = useState([]);
  const [hoveredCategory, setHoveredCategory] = useState(null);

  const getCategories = async () => {
    try {
      const response = await axios.get(`${config.apiUrl}/all/category`);
      setCategories(response.data.data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getCategories();
  }, []);

  const handleMouseEnter = (id) => {
    setHoveredCategory(id);
  };

  const handleMouseLeave = () => {
    setHoveredCategory(null);
  };

  return (
    <div className="container content-space-t-1 content-space-t-lg-2">
      <h2 className="text-center"> Our categories </h2>

      <div className="d-flex justify-content-center align-items-center">
        <button className="btn btn-link text-dark fs-4 shadow-sm rounded-circle">
          <FaChevronLeft />
        </button>
        <div className="d-flex flex-wrap justify-content-center mx-4 content-space-t-1">
          {categories.map((category) => (
            <Link to={`/market-place/category/${encodeURIComponent(btoa(category.id))}`} key={category.id}>
              <div
                onMouseEnter={() => handleMouseEnter(category.id)}
                onMouseLeave={handleMouseLeave}
                // key={category.id}
                className={`${
                  hoveredCategory === category.id ? " bg-secondary text-white fw-semibold" : ""
                } m-2 border border-2 rounded-circle p-3 d-flex align-items-center justify-content-center fs-6 text-center `}
                style={{ width: "140px", height: "140px", cursor: "pointer" }}
              >
                {category.name}
              </div>
            </Link>
          ))}
        </div>
        <button className="btn  btn-link text-dark fs-4 shadow-sm rounded-circle">
          <FaChevronRight />
        </button>
      </div>
    </div>
  );
};

export default Index;
